export default "__VITE_ASSET__CB$eawFR__"